var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTutorials(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 100,
    viewBox: "0 0 86 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.3333 42.4242C85.3333 40.8144 84.7708 39.2756 83.7708 38.1392C82.7708 37.0029 81.4167 36.3636 80 36.3636H64C63.9948 30.9955 62.4167 25.7812 59.5208 21.5376C56.6249 17.2939 52.5729 14.2636 48 12.9261V6.06061C48 2.71076 45.6145 0 42.6667 0C39.7188 0 37.3333 2.71076 37.3333 6.06061V12.9261C32.7604 14.2637 28.7083 17.2939 25.8125 21.5376C22.9167 25.7812 21.3385 30.9955 21.3333 36.3636H5.33333C2.38547 36.3636 0 39.0744 0 42.4242C0 45.7741 2.38547 48.4848 5.33333 48.4848V87.8788C2.38547 87.8788 0 90.5895 0 93.9394C0 97.2892 2.38547 100 5.33333 100H80C82.9479 100 85.3333 97.2892 85.3333 93.9394C85.3333 90.5895 82.9479 87.8788 80 87.8788V48.4848C81.4167 48.4848 82.7708 47.8456 83.7708 46.7092C84.7708 45.5728 85.3333 44.0341 85.3333 42.4242ZM26.6667 87.8788H16V48.4848H26.6667V87.8788ZM48 87.8788H37.3333V48.4848H48V87.8788ZM32 36.3636C32 29.6697 36.776 24.2424 42.6667 24.2424C48.5573 24.2424 53.3333 29.6697 53.3333 36.3636H32ZM69.3333 87.8788H58.6667V48.4848H69.3333V87.8788Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutorials);
export default __webpack_public_path__ + "static/media/tutorials.41b3b1e33d1ba3cf25eed34b969b4194.svg";
export { ForwardRef as ReactComponent };